import {
  CreateConsigne,
  UpdateConsigne,
} from "domain/entities/consignes.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const createConsigne = createAppAsyncThunk(
  "consignes/createConsigne",
  async (consigne: CreateConsigne, { extra: { consignesGateway } }) => {
    return await consignesGateway.createConsigne(consigne);
  }
);

export const getConsignesByTechniqueId = createAppAsyncThunk(
  "consignes/getConsignesByTechniqueId",
  async (techniqueId: number, { extra: { consignesGateway } }) => {
    return await consignesGateway.getConsignesByTechniqueId(techniqueId);
  }
);

export const deleteConsigne = createAppAsyncThunk(
  "consignes/deleteConsigne",
  async (consigneId: number, { extra: { consignesGateway } }) => {
    return await consignesGateway.deleteConsigne(consigneId);
  }
);

export const updateConsigne = createAppAsyncThunk(
  "consignes/updateConsigne",
  async (consigne: UpdateConsigne, { extra: { consignesGateway } }) => {
    return await consignesGateway.updateConsigne(consigne);
  }
);
